import {
    HOME_PAGE,
    RESULTS_PAGE,
    DETAILS_PAGE,
    ORDER_PAGE,
    CREDIT_CARD_PAGE,
    CONFIRMATION_PAGE
} from '@lts-web/types/PageNames';

import {
    CMS_PAGE,
    PROCESS_PAGE
} from '@lts-web/types/PageTypes';
import { readOnlyProperty } from '@lts-web/utils/ObjectUtil';

class PageContext {
    constructor({
        pageName = null,
        pageType = PROCESS_PAGE,
        staticPage = false
    } = {}) {
        this._data = {
            pageName,
            pageType,
            staticPage
        };

        readOnlyProperty(this, '_data');
    }

    updateData (data) {
        Object.assign(this._data, data);
    }

    getPageName() {
        return this._data.pageName;
    }

    setPageName(pageName) {
        this._data.pageName = pageName;
    }

    getPageType () {
        return this._data.pageType;
    }

    setPageType (type) {
        this._data.pageType = type;
    }

    setStaticPage(bool) {
        this._data.staticPage = bool;
    }

    isCMSPage() {
        return this._data.pageType === CMS_PAGE;
    }

    isProcessPage() {
        return this._data.pageType === PROCESS_PAGE;
    }

    isStaticPage() {
        return this._data.staticPage;
    }

    isHomePage() {
        return  this._data.pageName === HOME_PAGE;
    }

    isResultPage() {
        return  this._data.pageName === RESULTS_PAGE;
    }

    isOrderPage() {
        return  this._data.pageName === ORDER_PAGE;
    }

    isDetailsPage() {
        return  this._data.pageName === DETAILS_PAGE;
    }

    isCreditCard() {
        return  this._data.pageName === CREDIT_CARD_PAGE;
    }

    isConfirmationPage() {
        return  this._data.pageName === CONFIRMATION_PAGE;
    }
}

export default PageContext;